import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-item-button',
  templateUrl: './list-item-button.component.html',
  styleUrls: ['./list-item-button.component.scss'],
})
export class ListItemButtonComponent implements OnInit {
  @Input() header: string = '';
  @Input() text?: string;
  @Input() isButton?: boolean = false;
  @Input() color?: string | null = null;

  constructor() {}

  ngOnInit() {
    return;
  }
}
